export const HOME_SECTION_LIMITS = {
  FEATURED_PRODUCTS: 4,
  GOLD_QUOTES: 4,
  NEWS_ITEMS: 5,
} as const;

export const HOME_CTA_LABELS = {
  SHOP_NOW: "Mua ngay",
  VIEW_COLLECTION: "Khám phá bộ sưu tập",
  READ_NEWS: "Đọc thêm",
  VIEW_GOLD_PRICE: "Xem bảng giá đầy đủ",
} as const;

export const HOME_MOCK_DELAYS = {
  banners: 320,
  featuredProducts: 520,
  goldSnapshot: 420,
  collections: 680,
  news: 760,
} as const;

export const FOOTER_CONTACT = {
  brandName: "ERP GOLD",
  description:
    "Trang sức vàng bạc cao cấp, chế tác riêng cho khách hàng cá nhân và gia đình.",
  email: "support@erpkimhoan.vn",
  phone: "1900 6868",
  address: "12 Nguyen Hue, Quan 1, TP. Ho Chi Minh",
  hours: "08:00 - 21:00, Thu 2 - Chu Nhat",
} as const;
